import { render, staticRenderFns } from "./TemplateMessages.vue?vue&type=template&id=26446b2a&"
import script from "./TemplateMessages.vue?vue&type=script&lang=js&"
export * from "./TemplateMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports